/**
 * Cart preview image
 *
 * Replaces the cart line item thumbnail with the customer's generated
 * canvas preview when the line item carries a `_preview_image` property.
 */
(function () {
  'use strict';

  var PROPERTY_KEY = '_preview_image';

  function selectorEscape(value) {
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return CSS.escape(String(value));
    }
    return String(value).replace(/[^a-zA-Z0-9_-]/g, function (ch) {
      return '\\' + ch;
    });
  }

  function findRows(itemKey, itemId) {
    if (itemKey) {
      var byKey = document.querySelectorAll('[data-key="' + selectorEscape(itemKey) + '"]');
      if (byKey && byKey.length) return byKey;
    }
    if (itemId) {
      return document.querySelectorAll('[data-variant-id="' + selectorEscape(itemId) + '"]');
    }
    return [];
  }

  function applyToImg(img, url) {
    if (!img || !url) return;
    if (img.dataset.canvasPreviewSrc === url) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
    img.dataset.canvasPreviewSrc = url;
    img.dataset.canvasPreview = '1';
  }

  function applyToContainer(container, url) {
    if (!container) return;
    var imgs = container.querySelectorAll(
      'img.cart-items__media-image, img.cart-drawer__image, .cart-items__media img, [data-cart-item-image] img'
    );
    if (imgs && imgs.length) {
      imgs.forEach(function (img) {
        applyToImg(img, url);
      });
      return;
    }
    var fallback = container.querySelector('img');
    if (fallback) applyToImg(fallback, url);
  }

  function applyPreviewImages() {
    if (!document.body) return;
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        cart.items.forEach(function (item) {
          if (!item || !item.properties) return;
          var url = item.properties[PROPERTY_KEY];
          if (!url) return;
          var rows = findRows(item.key, item.variant_id || item.id);
          if (!rows || !rows.length) return;
          rows.forEach(function (row) {
            applyToContainer(row, url);
          });
        });
      })
      .catch(function () {});
  }

  var pendingApply = null;
  function scheduleApply() {
    if (pendingApply) return;
    pendingApply = window.setTimeout(function () {
      pendingApply = null;
      applyPreviewImages();
    }, 60);
  }

  function watchDom() {
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!(node instanceof Element)) continue;
          if (
            node.matches &&
            (node.matches('[data-key]') ||
              node.matches('cart-drawer-component') ||
              node.querySelector('[data-key], img.cart-items__media-image'))
          ) {
            scheduleApply();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    applyPreviewImages();
    watchDom();
    document.addEventListener('cart:update', scheduleApply);
    document.addEventListener('cart:add', scheduleApply);
    window.addEventListener('pageshow', applyPreviewImages);
    window.setTimeout(applyPreviewImages, 250);
    window.setTimeout(applyPreviewImages, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
